import { userConstants } from "../../constant";

export function sellerCollections(state = { collections: [] }, action) {
  switch (action.type) {
    case userConstants.GET_SELLER_COLLECTIONS:
      return { collections: action.payload };
    default:
      return state;
  }
}
